import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import {
  FDStack, FDPaper,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('WhatIfClientScenarioInsightContent', ((theme) => ({
  root: {
    maxWidth: theme.dimensions.lg,
  },
})));

export default function WhatIfClientScenarioInsightContent({
  hideTitle,
  resource: scenarioInsightResource,
  footerContent,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <FDStack
        direction={'column'}
        spacing={2}
        alignItems={'center'}
        justifyContent="flex-start"
      >
        {
          hideTitle ? null : (
            <Text
              variant={'h4'}
              color={'black'}
              weight={'bold'}
              value={scenarioInsightResource.attr('scenarioTitle')}
            />
          )
        }
        <FDPaper appearance={'flat'} color={'subtle'} padding={'400'} width={'100%'}>
          <RichTextDisplay
            align="left"
            color="mediumGray"
            content={scenarioInsightResource.attr('message')}
            variant="h6"
          />
          {footerContent}
        </FDPaper>
      </FDStack>
    </div>
  );
}

WhatIfClientScenarioInsightContent.defaultProps = {
  hideTitle: false,
  footerContent: undefined,
};
WhatIfClientScenarioInsightContent.propTypes = {
  hideTitle: PropTypes.bool,
  resource: PropTypes.object.isRequired,
  footerContent: PropTypes.node,
};
